export default __webpack_public_path__ + "static/media/2019-APP.5ccb7e14.jpg";